<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="136.694"
    height="14.999"
    viewBox="0 0 136.694 14.999"
  >
    <g>
      <g>
        <path
          class="st0"
          d="M1.7,10.5c0.1,1.9,1.2,2.9,3,2.9c1.7,0,2.8-0.9,2.8-2.6c0-1.3-0.6-2.1-2.6-3c-2.3-1-3.1-2-3.1-3.7
			c0-2.1,1.3-4,4.1-4s4,1.8,4,4H8.2C8.1,2.6,7.5,1.6,5.7,1.6c-1.6,0-2.4,1.1-2.4,2.3c0,1,0.4,1.6,2.3,2.4c2.6,1.1,3.5,2.4,3.5,4.3
			c0,2.3-1.2,4.4-4.6,4.4c-2.9,0-4.3-1.8-4.4-4.4h1.6V10.5z"
        />
        <path
          class="st0"
          d="M12.3,0.3h1.6l-1.1,6h6.3l1.1-6h1.6l-2.7,14.5h-1.6l1.3-7h-6.3l-1.3,7H9.7L12.3,0.3z"
        />
        <path class="st0" d="M25.6,0.3l-2.7,14.5h-1.6L24,0.3H25.6z" />
        <path
          class="st0"
          d="M25.2,14.7l2.7-14.5h2C31,3.5,33.5,11,33.8,12.6l0,0c0.2-1.8,0.7-4.3,1.1-6.7l1-5.7h1.5l-2.7,14.5h-1.9
			c-1-3.1-3.6-11.1-4-12.7l0,0c-0.2,1.9-0.7,4.2-1.2,6.8l-1.1,5.9C26.5,14.7,25.2,14.7,25.2,14.7z"
        />
        <path
          class="st0"
          d="M40.8,11.1c-0.5,2.5-1.3,3.9-3.5,3.9c-0.5,0-1.1-0.1-1.4-0.2l0.3-1.5c0.3,0.1,0.7,0.1,1.1,0.1
			c1.4,0,1.7-1.2,1.9-2.4l2-10.7h1.6L40.8,11.1z"
        />
        <path
          class="st0"
          d="M46.3,0.3l-1.6,8.9c-0.6,3.1,0.7,4.3,2.5,4.3c2.2,0,3.1-1.1,3.6-4.3l1.6-8.9H54l-1.7,9c-0.8,4-2,5.6-5.3,5.6
			c-2.8,0-4.7-1.7-4-5.9l1.6-8.8h1.7V0.3z"
        />
        <path
          class="st0"
          d="M56.1,0.3h1.6l-1.3,7.1c0.9-0.9,4.8-4.7,7.1-7.1h2l-6.3,6.2l3.9,8.3h-1.8L58,7.5l-2,1.7l-1,5.5h-1.6L56.1,0.3
			z"
        />
        <path
          class="st0"
          d="M67.4,0.3l-1.6,8.9c-0.6,3.1,0.7,4.3,2.5,4.3c2.2,0,3.1-1.1,3.6-4.3l1.6-8.9h1.6l-1.7,9c-0.8,4-2,5.6-5.3,5.6
			c-2.8,0-4.7-1.7-4-5.9l1.6-8.8h1.7V0.3z"
        />
      </g>
    </g>
    <g>
      <polygon class="st0" points="122.6,13.1 122.8,13.7 136.3,10.3 136,9.1 	" />
      <polygon class="st0" points="123,14.7 136.7,11.8 136.4,10.7 122.9,14.1 	" />
      <path
        class="st0"
        d="M126.1,7.3L126,8.8h5l-0.1-1.5c3.6-1.8,4.1-4.4,4.1-5.7h-13C122,2.9,122.5,5.6,126.1,7.3z"
      />
    </g>
    <g>
      <g>
        <path class="st0" d="M82,3.2h5.7v1.9h-3.5v1.3h3v1.9h-3v1.5h3.6v1.9H82V3.2z" />
        <path
          class="st0"
          d="M93.2,3.2h2.7l2.5,8.5H96l-0.9-4.1c-0.2-0.9-0.4-1.9-0.6-2.7h-0.1c-0.1,0.8-0.4,1.8-0.5,2.6l-1,4.2h-2.3
			L93.2,3.2z M92.5,8.1h4.1v1.7h-4.1V8.1z"
        />
        <path class="st0" d="M103.2,5.1h-2.4V3.2h7.1v1.9h-2.4v6.6h-2.2L103.2,5.1L103.2,5.1z" />
        <path
          class="st0"
          d="M110.4,10.6l1.3-1.5c0.6,0.5,1.4,0.8,2.2,0.8c0.7,0,0.9-0.2,0.9-0.5c0-0.5-0.4-0.6-1.2-0.9l-1.1-0.4
			c-1-0.4-1.8-1.2-1.8-2.4c0-1.4,1.3-2.6,3.2-2.6c1,0,2.1,0.4,2.9,1.1l-1.1,1.4c-0.6-0.4-1.1-0.6-1.9-0.6c-0.5,0-0.8,0.2-0.8,0.6
			s0.5,0.5,1.3,0.8l1,0.4c1.1,0.4,1.8,1.1,1.8,2.3c0,1.4-1.2,2.7-3.4,2.7C112.6,11.8,111.3,11.4,110.4,10.6z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "HeaderLogoSvg"
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/style.scss";
svg {
  display: inline-block;
  vertical-align: middle;
  margin: 0 0.8rem 0 4.5rem;
  @include mediaMobile {
    margin: 0 0.8rem 0 0;
  }
}
.st0 {
  fill: #dc3232;
}
</style>
